import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IDashboardResponse } from '../shared/models/contracts/dashboard-response';

@Injectable({ providedIn: 'root' })
export class DashboardService {
  constructor(private http: HttpClient) {}

  getData(): Observable<IDashboardResponse> {
    return this.http.get<IDashboardResponse>('/dashboard');
  }
}
